const PREFIX = '@entry';

export default {
  PREFIX,

  /* Socket */

  SOCKET_DISCONNECT_HANDLE: `${PREFIX}/SOCKET_DISCONNECT_HANDLE`,
  SOCKET_RECONNECT_HANDLE: `${PREFIX}/SOCKET_RECONNECT_HANDLE`,

  /* Login */

  AUTHENTICATE: `${PREFIX}/AUTHENTICATE`,
  AUTHENTICATE_ERROR_CLEAR: `${PREFIX}/AUTHENTICATE_ERROR_CLEAR`,
  AUTHENTICATE_SSO: `${PREFIX}/AUTHENTICATE_SSO`,
  REGISTER_OPEN: `${PREFIX}/REGISTER_OPEN`,
  LOGIN_OPEN: `${PREFIX}/LOGIN_OPEN`,
  REGISTER: `${PREFIX}/REGISTER`,
  REGISTER_ERROR_CLEAR: `${PREFIX}/REGISTER_ERROR_CLEAR`,

  /* Api Clients */

  API_CLIENT_CREATE: `${PREFIX}/API_CLIENT_CREATE`,
  API_CLIENT_CREATE_HANDLE: `${PREFIX}/API_CLIENT_CREATE_HANDLE`,
  API_CLIENT_UPDATE: `${PREFIX}/API_CLIENT_UPDATE`,
  API_CLIENT_UPDATE_HANDLE: `${PREFIX}/API_CLIENT_UPDATE_HANDLE`,
  API_CLIENT_DELETE: `${PREFIX}/API_CLIENT_DELETE`,
  API_CLIENT_DELETE_HANDLE: `${PREFIX}/API_CLIENT_DELETE_HANDLE`,

  /* Core */

  CORE_INITIALIZE: `${PREFIX}/CORE_INITIALIZE`,
  LOGOUT: `${PREFIX}/LOGOUT`,
  CORE_SETTINGS_UPDATE: `${PREFIX}/CORE_SETTINGS_UPDATE`,
  CORE_SETTINGS_UPDATE_HANDLE: `${PREFIX}/CORE_SETTINGS_UPDATE_HANDLE`,

  /* Modals */

  MODAL_OPEN: `${PREFIX}/MODAL_OPEN`,
  MODAL_CLOSE: `${PREFIX}/MODAL_CLOSE`,

  /* Users */

  USER_CREATE: `${PREFIX}/USER_CREATE`,
  USER_CREATE_HANDLE: `${PREFIX}/USER_CREATE_HANDLE`,
  USER_CREATE_ERROR_CLEAR: `${PREFIX}/USER_CREATE_ERROR_CLEAR`,
  USER_UPDATE: `${PREFIX}/USER_UPDATE`,
  CURRENT_USER_UPDATE: `${PREFIX}/CURRENT_USER_UPDATE`,
  USER_UPDATE_HANDLE: `${PREFIX}/USER_UPDATE_HANDLE`,
  USER_EMAIL_LOOKUP: `${PREFIX}/USER_EMAIL_LOOKUP`,
  USER_EMAIL_UPDATE: `${PREFIX}/USER_EMAIL_UPDATE`,
  CURRENT_USER_EMAIL_UPDATE: `${PREFIX}/CURRENT_USER_EMAIL_UPDATE`,
  CURRENT_USER_EMAIL_VERIFICATION_RESEND: `${PREFIX}/CURRENT_USER_EMAIL_VERIFICATION_RESEND`,
  USER_EMAIL_UPDATE_ERROR_CLEAR: `${PREFIX}/USER_EMAIL_UPDATE_ERROR_CLEAR`,
  CURRENT_USER_EMAIL_UPDATE_ERROR_CLEAR: `${PREFIX}/CURRENT_USER_EMAIL_UPDATE_ERROR_CLEAR`,
  USER_PASSWORD_UPDATE: `${PREFIX}/USER_PASSWORD_UPDATE`,
  CURRENT_USER_PASSWORD_UPDATE: `${PREFIX}/CURRENT_USER_PASSWORD_UPDATE`,
  USER_PASSWORD_UPDATE_ERROR_CLEAR: `${PREFIX}/USER_PASSWORD_UPDATE_ERROR_CLEAR`,
  CURRENT_USER_PASSWORD_UPDATE_ERROR_CLEAR: `${PREFIX}/CURRENT_USER_PASSWORD_UPDATE_ERROR_CLEAR`,
  USER_USERNAME_UPDATE: `${PREFIX}/USER_USERNAME_UPDATE`,
  CURRENT_USER_USERNAME_UPDATE: `${PREFIX}/CURRENT_USER_USERNAME_UPDATE`,
  USER_USERNAME_UPDATE_ERROR_CLEAR: `${PREFIX}/USER_USERNAME_UPDATE_ERROR_CLEAR`,
  CURRENT_USER_USERNAME_UPDATE_ERROR_CLEAR: `${PREFIX}/CURRENT_USER_USERNAME_UPDATE_ERROR_CLEAR`,
  CURRENT_USER_AVATAR_UPDATE: `${PREFIX}/CURRENT_USER_AVATAR_UPDATE`,
  CURRENT_USER_API_CLIENT_ERROR_CLEAR: `${PREFIX}/CURRENT_USER_API_CLIENT_ERROR_CLEAR`,
  USER_DELETE: `${PREFIX}/USER_DELETE`,
  USER_DELETE_HANDLE: `${PREFIX}/USER_DELETE_HANDLE`,
  USER_TO_CARD_ADD: `${PREFIX}/USER_TO_CARD_ADD`,
  USER_TO_CURRENT_CARD_ADD: `${PREFIX}/USER_TO_CURRENT_CARD_ADD`,
  USER_TO_CARD_ADD_HANDLE: `${PREFIX}/USER_TO_CARD_ADD_HANDLE`,
  USER_FROM_CARD_REMOVE: `${PREFIX}/USER_FROM_CARD_REMOVE`,
  USER_FROM_CURRENT_CARD_REMOVE: `${PREFIX}/USER_FROM_CURRENT_CARD_REMOVE`,
  USER_FROM_CARD_REMOVE_HANDLE: `${PREFIX}/USER_FROM_CARD_REMOVE_HANDLE`,
  USER_TO_TASK_ADD: `${PREFIX}/USER_TO_TASK_ADD`,
  USER_TO_TASK_ADD_HANDLE: `${PREFIX}/USER_TO_TASK_ADD_HANDLE`,
  USER_FROM_TASK_REMOVE: `${PREFIX}/USER_FROM_TASK_REMOVE`,
  USER_FROM_TASK_REMOVE_HANDLE: `${PREFIX}/USER_FROM_TASK_REMOVE_HANDLE`,
  USER_TO_FILTER_IN_CURRENT_BOARD_ADD: `${PREFIX}/USER_TO_FILTER_IN_CURRENT_BOARD_ADD`,
  USER_FROM_FILTER_IN_CURRENT_BOARD_REMOVE: `${PREFIX}/USER_FROM_FILTER_IN_CURRENT_BOARD_REMOVE`,
  CURRENT_USER_FILTER_QUERY_UPDATE: `${PREFIX}/CURRENT_USER_FILTER_QUERY_UPDATE`,
  CURRENT_USER_NOTIFICATION_FILTER_QUERY_UPDATE: `${PREFIX}/CURRENT_USER_NOTIFICATION_FILTER_QUERY_UPDATE`,

  /* User Prefs */

  CURRENT_USER_PREFS_UPDATE: `${PREFIX}/CURRENT_USER_PREFS_UPDATE`,
  USER_PREFS_UPDATE_HANDLE: `${PREFIX}/USER_PREFS_UPDATE_HANDLE`,

  /* Projects */

  PROJECT_CREATE: `${PREFIX}/PROJECT_CREATE`,
  PROJECT_CREATE_HANDLE: `${PREFIX}/PROJECT_CREATE_HANDLE`,
  PROJECT_UPDATE: `${PREFIX}/PROJECT_UPDATE`,
  CURRENT_PROJECT_UPDATE: `${PREFIX}/CURRENT_PROJECT_UPDATE`,
  PROJECT_UPDATE_HANDLE: `${PREFIX}/PROJECT_UPDATE_HANDLE`,
  PROJECT_BACKGROUND_IMAGE_UPDATE: `${PREFIX}/PROJECT_BACKGROUND_IMAGE_UPDATE`,
  CURRENT_PROJECT_BACKGROUND_IMAGE_UPDATE: `${PREFIX}/CURRENT_PROJECT_BACKGROUND_IMAGE_UPDATE`,
  PROJECT_DELETE: `${PREFIX}/PROJECT_DELETE`,
  CURRENT_PROJECT_DELETE: `${PREFIX}/CURRENT_PROJECT_DELETE`,
  PROJECT_DELETE_HANDLE: `${PREFIX}/PROJECT_DELETE_HANDLE`,
  PROJECT_IMPORT_GETTING_STARTED: `${PREFIX}/PROJECT_IMPORT_GETTING_STARTED`,

  /* Project Memberships */

  PROJECT_MEMBERSHIP_UPDATE: `${PREFIX}/PROJECT_MEMBERSHIP_UPDATE`,
  PROJECT_MEMBERSHIP_UPDATE_HANDLE: `${PREFIX}/PROJECT_MEMBERSHIP_UPDATE_HANDLE`,

  /* Project managers */

  MANAGER_IN_PROJECT_CREATE: `${PREFIX}/MANAGER_IN_PROJECT_CREATE`,
  MANAGER_IN_CURRENT_PROJECT_CREATE: `${PREFIX}/MANAGER_IN_CURRENT_PROJECT_CREATE`,
  PROJECT_MANAGER_CREATE_HANDLE: `${PREFIX}/PROJECT_MANAGER_CREATE_HANDLE`,
  PROJECT_MANAGER_DELETE: `${PREFIX}/PROJECT_MANAGER_DELETE`,
  PROJECT_MANAGER_DELETE_HANDLE: `${PREFIX}/PROJECT_MANAGER_DELETE_HANDLE`,

  /* Boards */

  BOARD_CREATE: `${PREFIX}/BOARD_CREATE`,
  BOARD_IN_CURRENT_PROJECT_CREATE: `${PREFIX}/BOARD_IN_CURRENT_PROJECT_CREATE`,
  BOARD_CREATE_HANDLE: `${PREFIX}/BOARD_CREATE_HANDLE`,
  BOARD_FETCH: `${PREFIX}/BOARD_FETCH`,
  BOARD_UPDATE: `${PREFIX}/BOARD_UPDATE`,
  BOARD_UPDATE_HANDLE: `${PREFIX}/BOARD_UPDATE_HANDLE`,
  BOARD_MOVE: `${PREFIX}/BOARD_MOVE`,
  BOARD_DELETE: `${PREFIX}/BOARD_DELETE`,
  BOARD_DELETE_HANDLE: `${PREFIX}/BOARD_DELETE_HANDLE`,
  BOARD_EXPORT: `${PREFIX}/BOARD_EXPORT`,
  BOARD_SEARCH_PARAMS_UPDATE: `${PREFIX}/BOARD_SEARCH_PARAMS_UPDATE`,

  /* Board templates */

  BOARD_TEMPLATE_CREATE: `${PREFIX}/BOARD_TEMPLATE_CREATE`,
  BOARD_TEMPLATE_CREATE_HANDLE: `${PREFIX}/BOARD_TEMPLATE_CREATE_HANDLE`,
  BOARD_TEMPLATE_UPDATE: `${PREFIX}/BOARD_TEMPLATE_UPDATE`,
  BOARD_TEMPLATE_UPDATE_HANDLE: `${PREFIX}/BOARD_TEMPLATE_UPDATE_HANDLE`,
  BOARD_TEMPLATE_DELETE: `${PREFIX}/BOARD_TEMPLATE_DELETE`,
  BOARD_TEMPLATE_DELETE_HANDLE: `${PREFIX}/BOARD_TEMPLATE_DELETE_HANDLE`,

  /* Board memberships */

  MEMBERSHIP_IN_CURRENT_BOARD_CREATE: `${PREFIX}/MEMBERSHIP_IN_CURRENT_BOARD_CREATE`,
  BOARD_MEMBERSHIP_CREATE_HANDLE: `${PREFIX}/BOARD_MEMBERSHIP_CREATE_HANDLE`,
  BOARD_MEMBERSHIP_UPDATE: `${PREFIX}/BOARD_MEMBERSHIP_UPDATE`,
  BOARD_MEMBERSHIP_UPDATE_HANDLE: `${PREFIX}/BOARD_MEMBERSHIP_UPDATE_HANDLE`,
  BOARD_MEMBERSHIP_DELETE: `${PREFIX}/BOARD_MEMBERSHIP_DELETE`,
  BOARD_MEMBERSHIP_DELETE_HANDLE: `${PREFIX}/BOARD_MEMBERSHIP_DELETE_HANDLE`,

  /* Labels */

  LABEL_IN_CURRENT_BOARD_CREATE: `${PREFIX}/LABEL_IN_CURRENT_BOARD_CREATE`,
  LABEL_CREATE_HANDLE: `${PREFIX}/LABEL_CREATE_HANDLE`,
  LABEL_UPDATE: `${PREFIX}/LABEL_UPDATE`,
  LABEL_UPDATE_HANDLE: `${PREFIX}/LABEL_UPDATE_HANDLE`,
  LABEL_DELETE: `${PREFIX}/LABEL_DELETE`,
  LABEL_DELETE_HANDLE: `${PREFIX}/LABEL_DELETE_HANDLE`,
  LABEL_TO_CARD_ADD: `${PREFIX}/LABEL_TO_CARD_ADD`,
  LABEL_TO_CURRENT_CARD_ADD: `${PREFIX}/LABEL_TO_CURRENT_CARD_ADD`,
  LABEL_TO_CARD_ADD_HANDLE: `${PREFIX}/LABEL_TO_CARD_ADD_HANDLE`,
  LABEL_FROM_CARD_REMOVE: `${PREFIX}/LABEL_FROM_CARD_REMOVE`,
  LABEL_FROM_CURRENT_CARD_REMOVE: `${PREFIX}/LABEL_FROM_CURRENT_CARD_REMOVE`,
  LABEL_FROM_CARD_REMOVE_HANDLE: `${PREFIX}/LABEL_FROM_CARD_REMOVE_HANDLE`,
  LABEL_TO_FILTER_IN_CURRENT_BOARD_ADD: `${PREFIX}/LABEL_TO_FILTER_IN_CURRENT_BOARD_ADD`,
  LABEL_FROM_FILTER_IN_CURRENT_BOARD_REMOVE: `${PREFIX}/LABEL_FROM_FILTER_IN_CURRENT_BOARD_REMOVE`,

  /* Lists */

  LIST_IN_CURRENT_BOARD_CREATE: `${PREFIX}/LIST_IN_CURRENT_BOARD_CREATE`,
  LIST_CREATE_HANDLE: `${PREFIX}/LIST_CREATE_HANDLE`,
  LIST_UPDATE: `${PREFIX}/LIST_UPDATE`,
  LIST_UPDATE_HANDLE: `${PREFIX}/LIST_UPDATE_HANDLE`,
  LIST_MOVE: `${PREFIX}/LIST_MOVE`,
  LIST_DELETE: `${PREFIX}/LIST_DELETE`,
  LIST_DELETE_HANDLE: `${PREFIX}/LIST_DELETE_HANDLE`,

  /* Mails */

  MAIL_TOKEN_CREATE: `${PREFIX}/MAIL_TOKEN_CREATE`,
  MAIL_TOKEN_CREATE_HANDLE: `${PREFIX}/MAIL_TOKEN_CREATE_HANDLE`,
  MAIL_TOKEN_UPDATE: `${PREFIX}/MAIL_TOKEN_UPDATE`,
  MAIL_TOKEN_UPDATE_HANDLE: `${PREFIX}/MAIL_TOKEN_UPDATE_HANDLE`,
  MAIL_TOKEN_DELETE: `${PREFIX}/MAIL_TOKEN_DELETE`,
  MAIL_TOKEN_DELETE_HANDLE: `${PREFIX}/MAIL_TOKEN_DELETE_HANDLE`,

  /* Cards */

  CARD_CREATE: `${PREFIX}/CARD_CREATE`,
  CARD_CREATE_HANDLE: `${PREFIX}/CARD_CREATE_HANDLE`,
  CARD_UPDATE: `${PREFIX}/CARD_UPDATE`,
  CURRENT_CARD_UPDATE: `${PREFIX}/CURRENT_CARD_UPDATE`,
  CARD_UPDATE_HANDLE: `${PREFIX}/CARD_UPDATE_HANDLE`,
  CARD_MOVE: `${PREFIX}/CARD_MOVE`,
  CURRENT_CARD_MOVE: `${PREFIX}/CURRENT_CARD_MOVE`,
  CARD_TRANSFER: `${PREFIX}/CARD_TRANSFER`,
  CURRENT_CARD_TRANSFER: `${PREFIX}/CURRENT_CARD_TRANSFER`,
  CARD_DUPLICATE: `${PREFIX}/CARD_DUPLICATE`,
  CURRENT_CARD_DUPLICATE: `${PREFIX}/CURRENT_CARD_DUPLICATE`,
  CARD_DUPLICATE_HANDLE: `${PREFIX}/CARD_DUPLICATE_HANDLE`,
  CARD_DELETE: `${PREFIX}/CARD_DELETE`,
  CURRENT_CARD_DELETE: `${PREFIX}/CURRENT_CARD_DELETE`,
  CARD_DELETE_HANDLE: `${PREFIX}/CARD_DELETE_HANDLE`,

  /* Tasks */

  TASK_CREATE: `${PREFIX}/TASK_CREATE`,
  TASK_IN_CURRENT_CARD_CREATE: `${PREFIX}/TASK_IN_CURRENT_CARD_CREATE`,
  TASK_CREATE_HANDLE: `${PREFIX}/TASK_CREATE_HANDLE`,
  TASK_UPDATE: `${PREFIX}/TASK_UPDATE`,
  TASK_UPDATE_HANDLE: `${PREFIX}/TASK_UPDATE_HANDLE`,
  TASK_DUPLICATE: `${PREFIX}/TASK_DUPLICATE`,
  TASK_DUPLICATE_HANDLE: `${PREFIX}/TASK_DUPLICATE_HANDLE`,
  TASK_MOVE: `${PREFIX}/TASK_MOVE`,
  TASK_DELETE: `${PREFIX}/TASK_DELETE`,
  TASK_DELETE_HANDLE: `${PREFIX}/TASK_DELETE_HANDLE`,

  /* Attachments */

  ATTACHMENT_IN_CURRENT_CARD_CREATE: `${PREFIX}/ATTACHMENT_IN_CURRENT_CARD_CREATE`,
  ATTACHMENT_CREATE_HANDLE: `${PREFIX}/ATTACHMENT_CREATE_HANDLE`,
  ATTACHMENT_UPDATE: `${PREFIX}/ATTACHMENT_UPDATE`,
  ATTACHMENT_UPDATE_HANDLE: `${PREFIX}/ATTACHMENT_UPDATE_HANDLE`,
  ATTACHMENT_DELETE: `${PREFIX}/ATTACHMENT_DELETE`,
  ATTACHMENT_DELETE_HANDLE: `${PREFIX}/ATTACHMENT_DELETE_HANDLE`,

  /* Activities */

  ACTIVITIES_ATTACHMENT_FETCH: `${PREFIX}/ACTIVITIES_ATTACHMENT_FETCH`,
  ACTIVITIES_COMMENT_FETCH: `${PREFIX}/ACTIVITIES_COMMENT_FETCH`,
  ACTIVITIES_TASK_FETCH: `${PREFIX}/ACTIVITIES_TASK_FETCH`,
  ACTIVITIES_IN_CURRENT_CARD_FETCH: `${PREFIX}/ACTIVITIES_IN_CURRENT_CARD_FETCH`,
  ACTIVITIES_CARD_FETCH: `${PREFIX}/ACTIVITIES_CARD_FETCH`,
  ACTIVITIES_LIST_FETCH: `${PREFIX}/ACTIVITIES_LIST_FETCH`,
  ACTIVITIES_BOARD_FETCH: `${PREFIX}/ACTIVITIES_BOARD_FETCH`,
  ACTIVITIES_PROJECT_FETCH: `${PREFIX}/ACTIVITIES_PROJECT_FETCH`,
  ACTIVITIES_USER_FETCH: `${PREFIX}/ACTIVITIES_USER_FETCH`,
  ACTIVITIES_USER_ACCOUNT_FETCH: `${PREFIX}/ACTIVITIES_USER_ACCOUNT_FETCH`,
  ACTIVITIES_INSTANCE_FETCH: `${PREFIX}/ACTIVITIES_INSTANCE_FETCH`,
  ACTIVITY_CREATE_HANDLE: `${PREFIX}/ACTIVITY_CREATE_HANDLE`,

  /* Comments */

  COMMENTS_IN_CURRENT_CARD_FETCH: `${PREFIX}/COMMENTS_IN_CURRENT_CARD_FETCH`,
  COMMENTS_IN_CARD_FETCH: `${PREFIX}/COMMENTS_IN_CARD_FETCH`,
  COMMENT_IN_CURRENT_CARD_CREATE: `${PREFIX}/COMMENT_IN_CURRENT_CARD_CREATE`,
  COMMENT_UPDATE: `${PREFIX}/COMMENT_UPDATE`,
  COMMENT_DELETE: `${PREFIX}/COMMENT_DELETE`,
  COMMENT_CREATE_HANDLE: `${PREFIX}/COMMENT_CREATE_HANDLE`,
  COMMENT_UPDATE_HANDLE: `${PREFIX}/COMMENT_UPDATE_HANDLE`,
  COMMENT_DELETE_HANDLE: `${PREFIX}/COMMENT_DELETE_HANDLE`,

  /* Notifications */

  NOTIFICATION_CREATE_HANDLE: `${PREFIX}/NOTIFICATION_CREATE_HANDLE`,
  NOTIFICATION_UPDATE: `${PREFIX}/NOTIFICATION_UPDATE`,
  NOTIFICATION_UPDATE_HANDLE: `${PREFIX}/NOTIFICATION_UPDATE_HANDLE`,
  NOTIFICATION_MARK_ALL_AS: `${PREFIX}/NOTIFICATION_MARK_ALL_AS`,
  NOTIFICATION_MARK_ALL_AS_HANDLE: `${PREFIX}/NOTIFICATION_MARK_ALL_AS_HANDLE`,
  NOTIFICATION_DELETE: `${PREFIX}/NOTIFICATION_DELETE`,
  NOTIFICATION_DELETE_HANDLE: `${PREFIX}/NOTIFICATION_DELETE_HANDLE`,
  NOTIFICATION_DELETE_ALL: `${PREFIX}/NOTIFICATION_DELETE_ALL`,
  NOTIFICATION_DELETE_ALL_HANDLE: `${PREFIX}/NOTIFICATION_DELETE_ALL_HANDLE`,

  SYSTEM_NOTIFICATION_RESPONSE_SUBMIT: `${PREFIX}/SYSTEM_NOTIFICATION_RESPONSE_SUBMIT`,
};
